export function callIfFunction<T extends number | undefined>(value: T | (() => T)) {
  if (typeof value === 'function') return value();
  return value;
}
